module.exports = __webpack_public_path__ + "img/general.df8d2861.svg";